import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

let translationPT = {};
if (process.env.NODE_ENV === 'test') {
  translationPT = require('../../../../public/locales/pt-BR/translation.json')
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "pt-BR",
    debug: false,
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "b", "i"],
    },
    ...(process.env.NODE_ENV === 'test' ? {
      resources: {
        'pt-BR': {
          translation: translationPT
        }
      },
    } : {})
  });

export default i18n;